export default __webpack_public_path__ + "static/media/payment-cards.18589b02.png";